module.exports = __webpack_public_path__ + "static/media/random 2.f307f726.jpg";